import { Component, OnInit, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CustomFormControl, CustomFormControlDefinition } from '../../../shared/utils/custom-form-control';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ModalService } from '../nz-modal-service/modal.service';
import { BaseFormComponent } from '../base-form/base-form.component';

@Component({
	selector: 'app-decline-request-modal',
	templateUrl: './decline-request-modal.component.html',
	//styleUrls: ['./decline-request-modal.component.scss']
})
export class DeclineRequestModalComponent  extends BaseFormComponent implements OnInit {

	pin: any;
	disabled = true;
	runningModal: any;
	@Input() modalData: any;
	@Output() submit: EventEmitter<any> = new EventEmitter();
	@Output() goBack: EventEmitter<any> = new EventEmitter();
	descControl: CustomFormControlDefinition;
	isLoading = false;
	error: boolean;
	errorMessage: any;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		public modalService: ModalService,
		public modal: NzModalRef,
		private fb: FormBuilder
	) { 
		super(fb);
	}

	ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.descControl = new CustomFormControl()
			.id('desc')
			.placeholder('desc')
			.name('desc')
			.type('text')
			.isRequired()
			.build();

		this.form = this.fb.group({
			desc: this.descControl.formGroupControl,
		});
	}

	verifyPin = (value: any) => {
		this.pin = value;
		if (this.pin.length === 4) {
			this.disabled = false;
		} else {
			this.disabled = true;
		}
	}

	submitEvent() {
		this.isLoading = true;
		const data = {
			transactionPin: this.pin
		};
		this.validateUserPin(data);
	}

	validateUserPin(data: any) {
		this.isLoading = true;
		this.disabled = true;
		this.modal.componentInstance.callback(this.form.value.desc);

	}

	handleCloseModal() {
		this.runningModal.destroy();
	}
}
